import React from 'react';
import { connect } from 'react-redux';
import { Breadcrumb, Grid, Icon, Menu, Tab, TabPane } from 'semantic-ui-react';
import styled from 'styled-components';
import UploadImages from './UploadIMG/UploadImages';
import Galeria from './Galeria/Galeria';
import Vitrine from './Vitrine/Vitrine';
import Aprovacao from './Aprovacao/Aprovacao.js';

// Importar sua action do Redux
import { novoClienteChangeTabAction, SearchSKUgaleriaAction } from '../../actions/EspacoTecaActions';

function EspacoTeca(props) {
    const { novoClienteChangeTabAction, tabindex, SearchSKUgaleriaAction, userid } = props;

    const StyledTab = styled(Tab)`
    &&& {
        .ui.tabular.menu .item{
            font-size:10px !important;
            height:10px !important;
        }
        .ui.menu{
            min-height: 0.0em !important;
        }
    }`;

    // Função corrigida sem usar this
    const handleTabChange = (e, { activeIndex }) => {
        novoClienteChangeTabAction(activeIndex);

    };

    const navigateToVitrine = (sku) => {
        novoClienteChangeTabAction(2);
        SearchSKUgaleriaAction(sku)
        // console.log('Navegar para visitas do codparc:', sku);
        // Aqui você pode chamar outras actions ou navegar
    };
    const navigateToGaleria = () => {
        novoClienteChangeTabAction(3);
        // SearchSKUgaleriaAction(sku)
        // console.log('Navegar para visitas do codparc:', sku);
        // Aqui você pode chamar outras actions ou navegar
    };



    let panes = [
        {
            menuItem: <Menu.Item key='TAB1'><Icon name='image' />Carregar Imagens</Menu.Item>,
            render: () => (
                <TabPane>
                    <UploadImages />
                </TabPane>
            )
        }
    ];
    if (userid == 2 || userid == 3 || userid == 47 || userid == 70 || userid == 79 || userid == 86 || userid == 87 || userid == 101 || userid == 156 || userid == 166 || userid == 171) {
        panes.push({
            menuItem: <Menu.Item key='TAB2'><Icon name='like' />Aprovação</Menu.Item>,
            render: () => (
                <TabPane>
                    <Aprovacao />
                </TabPane>
            )
        })
    }

    panes.push({
        menuItem: <Menu.Item key='TAB3'><Icon name='camera retro' />Galeria</Menu.Item>,
        render: () => (
            <TabPane>
                <Galeria navigateToGaleria={navigateToGaleria} />
            </TabPane>
        )
    },
        {
            menuItem: <Menu.Item key='TAB4'><Icon name='columns' />Vitrine</Menu.Item>,
            render: () => (
                <TabPane>
                    <Vitrine navigateToVitrine={navigateToVitrine} />
                </TabPane>
            )
        })





    return (
        <div style={{ padding: '1em 0' }}>
            <Menu stackable size='mini' style={{ background: 'transparent', border: 'none', borderBottom: 'solid 1.5px #1884af', boxShadow: 'none', borderRadius: '0 0 5px 5px' }}>
                <Menu.Item >
                    <Breadcrumb size='mini'>
                        <Breadcrumb.Section href="/Home">Home</Breadcrumb.Section>
                        <Breadcrumb.Divider icon='right chevron' />
                        <Breadcrumb.Section active>EspaçoTeca</Breadcrumb.Section>
                    </Breadcrumb>
                </Menu.Item>
            </Menu>

            <Grid columns={1} doubling>
                <Grid.Column>
                    <StyledTab panes={panes} onTabChange={handleTabChange} activeIndex={tabindex} />
                </Grid.Column>
            </Grid>


            <style>{`

                    /*-------------------------------*/
                    /*Menu Superior*/


                    .ui.mini.menu>.item{
                        padding: 0;
                    }

                    .ui.breadcrumb .section {
                        padding: 1.5em 1.5em !important;
                    }
                    
                    .ui.breadcrumb .section:first-child {
                        padding-right: 0 !important;
                        border-radius: 0 0 0 5px !important;
                    }
                        

                    .ui.breadcrumb .active.section {
                        background-color: #1884af !important;
                        color: #fff !important;
                    }
                `}</style>

        </div>
    );
}

// Conecta ao Redux
const mapStateToProps = (state) => ({
    tabindex: state.EspacoTecaReducer.tabindex,
    userid: state.LoginReducer.userid
});

export default connect(mapStateToProps, { novoClienteChangeTabAction, SearchSKUgaleriaAction })(EspacoTeca);
